import React from "react";
import { useTranslation } from "react-i18next";
import { FiUser, FiArrowDownCircle, FiArrowUpCircle, FiTrendingUp } from "react-icons/fi";

const InvestorDashboardCard = ({ investor }) => {
  const { t } = useTranslation();
  const balance = investor.balance.toFixed(2);
  const isPositive = investor.balance >= 0;

  return (
    <div className="space-y-4">
      {/* Investor name header */}
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center text-primary shrink-0">
          <FiUser className="text-lg" />
        </div>
        <div>
          <h2 className="text-lg font-bold text-base-content">{investor.name}</h2>
          <p className="text-xs text-base-content/40">{t("investors.overview", { defaultValue: "Apercu du compte" })}</p>
        </div>
      </div>

      {/* Stat cards */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {/* Deposits */}
        <div className="bg-base-100 rounded-xl border border-base-200 shadow-sm p-5 flex flex-col gap-2">
          <div className="flex items-center gap-2">
            <FiArrowDownCircle className="text-success text-base shrink-0" />
            <span className="text-xs font-semibold tracking-wider text-base-content/40 uppercase">
              {t("investors.deposits")}
            </span>
          </div>
          <div className="text-2xl font-black tracking-tight text-base-content tabular-nums">
            €{investor.totalDeposits.toFixed(2)}
          </div>
          <span className="text-xs text-base-content/40">
            {t("investors.depositsDesc", { defaultValue: "Total des dépôts" })}
          </span>
        </div>

        {/* Withdrawals */}
        <div className="bg-base-100 rounded-xl border border-base-200 shadow-sm p-5 flex flex-col gap-2">
          <div className="flex items-center gap-2">
            <FiArrowUpCircle className="text-error text-base shrink-0" />
            <span className="text-xs font-semibold tracking-wider text-base-content/40 uppercase">
              {t("investors.withdrawals")}
            </span>
          </div>
          <div className="text-2xl font-black tracking-tight text-base-content tabular-nums">
            €{investor.totalWithdrawals.toFixed(2)}
          </div>
          <span className="text-xs text-base-content/40">
            {t("investors.withdrawalsDesc", { defaultValue: "Total des retraits" })}
          </span>
        </div>

        {/* Balance */}
        <div className="bg-base-100 rounded-xl border border-base-200 shadow-sm p-5 flex flex-col gap-2">
          <div className="flex items-center gap-2">
            <FiTrendingUp className={`text-base shrink-0 ${isPositive ? "text-success" : "text-error"}`} />
            <span className="text-xs font-semibold tracking-wider text-base-content/40 uppercase">
              {t("investors.balance")}
            </span>
          </div>
          <div className={`text-2xl font-black tracking-tight tabular-nums ${isPositive ? "text-success" : "text-error"}`}>
            €{balance}
          </div>
          <span className="text-xs text-base-content/40">
            {t("investors.balanceDesc", { defaultValue: "Solde actuel" })}
          </span>
        </div>
      </div>
    </div>
  );
};

export default InvestorDashboardCard;
